import { Case } from "@/types/workflow";
import { CasesTable } from "./CasesTable";

interface CasesTableSectionProps {
  cases: Case[];
  onEdit: (caseData: Case) => void;
  onDelete: (caseData: Case) => void;
  onViewWorkflow: (caseData: Case) => void;
}

export function CasesTableSection({
  cases,
  onEdit,
  onDelete,
  onViewWorkflow,
}: CasesTableSectionProps) {
  return (
    <div className="w-full overflow-hidden rounded-lg">
      <div className="w-full overflow-x-auto">
        <div className="min-w-[1024px]"> {/* Ensure minimum width to prevent squishing */}
          <CasesTable
            cases={cases}
            onEdit={onEdit}
            onDelete={onDelete}
            onViewWorkflow={onViewWorkflow}
          />
        </div>
      </div>
    </div>
  );
}